export enum ERequestType {
  GET = 'GET',
  POST = 'POST',
}

export enum ERequestStatus {
  success = 'success',
  failed = 'failed',
  pending = 'pending',
  none = 'none',
}
